module.exports = __webpack_public_path__ + "img/document.c06d236b.svg";